@if (data) {
  <div class="sectors__list-body" areaModal>
    @if (data.length) {
      <div class="row sectors--row">
        @for (elem of data; track elem; let i = $index) {
          <div
            #content
            class="md-4 xs-6 sectors--col"
				[ngClass]="{
					'col-3': !reducedColumnSet,
					'col-4': reducedColumnSet
				}"
            >
            <div
              class="sector__wrapper"
              (click)="modalOpen(i)"
              [class.active]="i == modal.index"
              [id]="'block_' + i"
              (keydown)="handleItemBlur($event)"
              [attr.data-item-index]="'' + i"
              >
              <span class="sector__wrapper--pic">
                @if (elem.fieldOskaFieldPicture | arrayFirst; as IEntry) {
                  <img
                    alt=""
                    [title]="IEntry.title"
                    [src]="IEntry.url"
                    />
                }
                @if (!(elem.fieldOskaFieldPicture | arrayFirst)) {
                  <img
                    alt=""
                    title="{{ 'errors.img_missing' | translate }}"
                    src="../../assets/img/1208x680.png"
                    />
                }
                <span class="overlay"></span>
              </span>
              <button
                attr.aria-label="{{ elem.title }}"
                class="sector__wrapper--title"
                [id]="'block_button_' + i"
                [attr.data-item-button-index]="'' + i"
                >
                <span class="sector__title">{{ elem.title }}</span>
              </button>
            </div>
          </div>
          @if (modal && modal.position == i) {
            <div class="col-12" (keydown)="storeEventTabState($event)" (focusout)="handleModalBlur($event)"  #blockModal>
              <div
                class="modal links-{{ links }}"
                id="modal"
                attr.aria-label="{{ 'oskaProfessions.card_opened' | translate }}"
                >
                <div class="modal__header">
                  <div class="modal__header__col">
                    <h1>
                      <a
                        id="dropdown-list-modal-title"
                        [routerLink]="modal.path"
                        [attr.data-modal-index]="'' + modal.index"
                        >{{ modal.title }}</a
                        >
                      </h1>
                    </div>
                    <!--/modal__header__col-->
                    <div class="modal__header__col">
                      <button
                        htm-button
                        theme="icon"
                        attr.aria-label="{{ 'oskaProfessions.card_close' | translate }}"
                        (click)="modalClose()"
                        >
                        <icon glyph="x" size="medium"></icon>
                      </button>
                    </div>
                    <!--/modal__header__col-->
                  </div>
                  <div class="modal__content">
                    <div class="row">
                      <div class="col-8 xs-12">
                        @if (!excludeTitle) {
                          <h2>
                            {{ 'oskaProfessions.general_info' | translate }}
                          </h2>
                        }
                        @if (modal.fieldIntroduction) {
                          <p>
                            {{ modal.fieldIntroduction }}
                          </p>
                        }
                        <a
                          aria-describedby="dropdown-list-modal-title"
                          [routerLink]="modal.path"
                          >{{ 'button.read_on' | translate }}</a
                          >
                        </div>
                        <!--/col-->
                        <div class="col-4 xs-12">
                          <div class="separator xs-hide"></div>
                          <hr class="xs-show" aria-hidden="true" />
                          <div class="modal__padding">
                            @if (
                              !(modal.fieldOskaFieldPicture | arrayFirst) &&
                              !modal.videoUrl
                              ) {
                              <div
                                class="modal__image"
											[ngStyle]="{
												'background-image': 'url(../../assets/img/1208x680.png)'
											}"
                                >
                                <img
                                  alt=""
                                  title="{{ 'errors.img_missing' | translate }}"
                                  src="../../assets/img/1208x680.png"
                                  />
                                </div>
                                <!--/modal__image-->
                              }
                              @if (
                                (modal?.fieldOskaFieldPicture | arrayFirst)?.url &&
                                !modal.videoUrl
                                ) {
                                @if (
                                  modal?.fieldOskaFieldPicture | arrayFirst; as Picture
                                  ) {
                                  <div
                                    class="modal__image"
												[ngStyle]="{
													'background-image': 'url(' + Picture.url + ')'
												}"
                                    >
                                    <img
                                      [src]="Picture.url"
                                      alt=""
                                      [title]="Picture.title"
                                      />
                                    </div>
                                    <!--/modal__image-->
                                  }
                                }
                                @if (modal.videoUrl) {
                                  <div class="modal__video">
                                    <iframe
												attr.aria-label="{{
													'generic.youtube_video' | translate
												}}"
                                      title="{{ 'generic.youtube_video' | translate }}"
                                      [src]="modal.videoUrl | iframe"
                                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                      allowfullscreen
                                    ></iframe>
                                  </div>
                                  <!--/modal__video-->
                                }
                              </div>
                              <!--/modal__padding-->
                            </div>
                            <!--/col-->
                          </div>
                          <hr aria-hidden="true" />
                          @if ((modal.list || modal.subentities)?.length > 0) {
                            <h2>{{ 'oska.professions_and_jobs' | translate }}</h2>
                            <ul>
                              @for (item of modal.list || modal.subentities; track item) {
                                <li>
                                  @if (item?.title) {
                                    <a
                                      [routerLink]="item?.path"
                                      [title]="item?.title"
                                      >
                                      {{ item.title }}
                                    </a>
                                  }
                                </li>
                              }
                            </ul>
                          }
                          @if (modal.fieldLinks?.length) {
                            <ul>
                              @for (item of modal.fieldLinks; track item) {
                                <li>
                                  @if (item?.title) {
                                    <a
										[href]="
											item.fieldWebpageLink
												? item.fieldWebpageLink[0]?.uri
												: item?.path
										"
                                      [title]="item?.title"
                                      target="_blank"
                                      >
                                      {{ item.title }}
                                    </a>
                                  }
                                </li>
                              }
                            </ul>
                          }
                        </div>
                        <!--/modal__content-->
                      </div>
                    </div>
                  }
                }
              </div>
            }
          </div>
        }
        @if (errMessage && !data) {
          <div class="sectors__list-body">
            <div class="text-center actions__error">
              <p role="alert">{{ 'errors.request' | translate }}</p>
            </div>
          </div>
        }
